import _ from "lodash";
import getPossibleSeasons from "@/helpers/events/getPossibleSeasons";

export default function getCurrentSeason(community) {
  const possibleSeasons = getPossibleSeasons(community);

  return {
    test: _.find(possibleSeasons, { _id: "into_orbit" }),
    "fll-brasil": _.find(possibleSeasons, { _id: "cargo_connect" }),
    "fll-brasil": _.find(possibleSeasons, { _id: "unearthed" }),
    "frc-brasil": _.find(possibleSeasons, { _id: "rebuilt" }),
    "ftc-brasil": _.find(possibleSeasons, { _id: "decode" }),
    "f1-brasil": _.find(possibleSeasons, { _id: "2026" }),
    desafiocovid: _.find(possibleSeasons, { _id: "2020" }),
    desafiorelampago: _.find(possibleSeasons, { _id: "2020" }),
    "fll-open-brazil": _.find(possibleSeasons, { _id: "cargo_connect" }),
    "off-season-sesi-mt": _.find(possibleSeasons, { _id: "off_season" }),
  }[community];
}



// WEBPACK FOOTER //
// ./src/helpers/events/getCurrentSeason.js